import { render, staticRenderFns } from "./UgiDropdownButton.vue?vue&type=template&id=d5beb21e&scoped=true&"
import script from "./UgiDropdownButton.vue?vue&type=script&lang=js&"
export * from "./UgiDropdownButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5beb21e",
  null
  
)

export default component.exports